import type { ServerMessages } from '@/i18n/messages/en/errors/index.ts'

/** What the groups domain's refusals say, in English (the source of truth AND the type). */
export const groups: Pick<
  ServerMessages,
  | 'groups.gone'
  | 'groups.not_found'
  | 'groups.picked_one_is_gone'
  | 'groups.name_taken'
  | 'groups.not_created'
  | 'groups.nothing_to_change'
  | 'groups.changed_while_editing'
  | 'groups.only_administrators'
  | 'groups.members_are_private'
  | 'groups.only_managers_can_add'
  | 'groups.only_managers_can_remove'
  | 'groups.only_managers_can_find_people'
  | 'groups.no_longer_managed_by_you'
  | 'groups.service_account_cannot_manage'
  | 'groups.deactivated_account_cannot_manage'
  | 'groups.confirm_name_to_delete'
  | 'groups.deletion_changed'
  | 'groups.new_owner_required'
  | 'groups.new_owner_must_differ'
> = {
  'groups.gone': () => 'That group no longer exists.',
  'groups.not_found': () => 'There is no group with that id.',
  'groups.picked_one_is_gone': () => 'A group you picked no longer exists. Reload and choose again.',

  'groups.name_taken': ({ name }) => `There is already a group called “${name}”.`,
  'groups.not_created': () => 'The group could not be created.',
  'groups.nothing_to_change': () => 'There is nothing to change.',
  'groups.changed_while_editing': () =>
    'Someone changed this group while you were editing it. Reload it and try again.',

  'groups.only_administrators': () => 'Only administrators can do this with groups.',
  'groups.members_are_private': () =>
    'Only this group’s members, its managers and administrators can see who is in it.',
  'groups.only_managers_can_add': () => 'Only its managers and administrators can add people.',
  'groups.only_managers_can_remove': () => 'Only its managers and administrators can remove people.',
  'groups.only_managers_can_find_people': () => 'Only group managers and administrators can look people up.',
  'groups.no_longer_managed_by_you': () => 'You no longer manage this group.',

  'groups.service_account_cannot_manage': () => 'A service account cannot manage a group.',
  'groups.deactivated_account_cannot_manage': () => 'That account is deactivated, so it cannot manage a group.',

  'groups.confirm_name_to_delete': ({ name }) => `Type ${name} to confirm that this group should be deleted.`,
  'groups.deletion_changed': () =>
    'What deleting this group changes has changed since you looked. Review it again before deleting.',
  'groups.new_owner_required': () => 'Choose who owns what this group owns before deleting it.',
  'groups.new_owner_must_differ': () => 'Choose a different group to own these.'
}
